// src/pages/NotFound.js — 존재하지 않는 경로 안내 (catch-all 라우트)
// AppHeader는 로그인 상태를 전제하므로 쓰지 않는다 — 이 페이지는 비로그인으로도 도달 가능
import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/NotFound.css';

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="not-found-page">
            <div className="not-found-card">
                <div className="not-found-emoji">🧭</div>
                <h1 className="not-found-code">404</h1>
                <h2 className="not-found-title">페이지를 찾을 수 없어요</h2>
                <p className="not-found-message">
                    주소가 잘못되었거나, 삭제된 페이지일 수 있어요.
                </p>
                <button
                    className="not-found-home-btn"
                    onClick={() => navigate('/home')}
                >
                    홈으로 가기
                </button>
            </div>
        </div>
    );
};

export default NotFound;
